import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { STEPS } from '../data/catalog';

const Engagement = () => {
  const [active, setActive] = useState(0);
  const step = STEPS[active];

  return (
    <section className="band band-line" id="engagement">
      <div className="wrap">
        <motion.div
          className="section-head"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="eyebrow-dark">Engagement Model</span>
          <h2>Governed delivery, from discovery to operations</h2>
          <p>
            Every engagement follows a structured method &mdash; grounded in TOGAF ADM governance and
            PMP delivery discipline.
          </p>
        </motion.div>

        <div className="stepper">
          {STEPS.map((s, i) => (
            <button
              key={s.n}
              className={`step-btn ${active === i ? 'active' : ''}`}
              onClick={() => setActive(i)}
            >
              <div className="s-index">{s.n}</div>
              <div className="s-title">{s.title}</div>
            </button>
          ))}
        </div>

        <motion.div key={active} className="step-panel" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
          <div>
            <h4>Activities</h4>
            <ul>{step.activities.map((a) => <li key={a}>{a}</li>)}</ul>
          </div>
          <div>
            <h4>Output</h4>
            <ul>{step.output.map((o) => <li key={o}>{o}</li>)}</ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Engagement;
